import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmQueuesLandingRoute: InvariantJiraRoute = {
	name: 'csm-queues-landing',
	path: '/jira/customer-service-management/projects/:projectKey/queues/(default|custom)?',
	exact: true,
};
